import apiClient from "../config/apiClient"; // Import your API client
import { API_ENDPOINTS } from "../config/endpoints"; // Replace this with the actual endpoint for your use case
import { handleApiError } from "../config/errorHandler"; // Import your error handler

export const getOrderStatus = async (orderNo) => {
  const payload = {
    order_no: orderNo,
  };

  try {
    const response = await apiClient.post(API_ENDPOINTS.ORDER_STATUS, payload);
    return response.data.data; // Return the response data
  } catch (error) {
    handleApiError(error); // Handle any errors
    throw error; // Rethrow the error for further handling
  }
};
